<template>
  <b-badge v-show="title" :title="title" :variant="status">
    {{ title }}
  </b-badge>
</template>

<script>
export default {
  props: ["tag"],
  data() {
    return {
      title: "",
      status: "dark",
    };
  },
  methods: {
    getStatus() {
      switch (this.tag) {
        case "standard":
          this.title = "Padrão";
          this.status = "dark";
          break;
        case "express":
          this.title = "Expressa";
          this.status = "dark";
          break;
        case "onehour":
          this.title = "Motoboy";
          this.status = "dark";
          break;
        case "pickup":
          this.title = "Retirada";
          this.status = "dark";
          break;
        case "economy":
          this.title = "Econômica";
          this.status = "dark";
          break;
        case "guaranteed":
          this.title = "Garantida";
          this.status = "dark";
          break;
        case "scheduled":
          this.title = "Agendada";
          this.status = "dark";
          break;
        case "international":
          this.title = "Internacional";
          this.status = "dark";
          break;
        case "fulfillment":
          this.title = "Fulfillment";
          this.status = "warning";
          break;
        case "fastshipping":
          this.title = "Coleta Rápida";
          this.status = "warning";
          break;
      }
    },
  },
  beforeMount() {
    this.getStatus();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/DeliveryType.vue